<template src="./AppSearchCity.html"></template>

<script>
import "vue-simple-suggest/dist/styles.css";
import VueSimpleSuggest from "vue-simple-suggest/dist/cjs"; // Note: import must be from 'vue-simple-suggest/dist/cjs'.for fix bug in android 4,5.

import { BaseDialog } from "@/components/BaseDialog";
import { locationAPI } from "@/api";
import { VersionTypesEnum, LanguagesEnum } from "@/enums";

export default {
  name: "AppSearchCity",

  components: {
    BaseDialog,
    VueSimpleSuggest,
  },

  data() {
    return {
      selectedCity: null,
      isLoading: false,
      noResult: false,
      searchCityControl: "",
      persianAlphabetRegex:
        /^[\u0600-\u06FF\uFB8A\u067E\u0686\u06AF7\u200C\u200F ]+$/,
      languagesEnum: LanguagesEnum,
    };
  },

  // watch: {
  //   "$store.state.isSearchCityOpen"() {
  //     if (this.$store.state.isSearchCityOpen)
  //       this.$nextTick(() => this.setFocus());
  //   },
  // },

  mounted() {
    setTimeout(() => {
      document.querySelector(".vue-simple-suggest input").focus();
    });
  },

  computed: {
    isPersianAlphabet() {
      if (this.searchCityControl.length < 1) return true;

      return this.persianAlphabetRegex.test(this.searchCityControl);
    },
  },

  methods: {
    getCities() {
      if (this.searchCityControl.length < 2) return;

      this.noResult = false;
      return new Promise((resolve, reject) => {
        this.isLoading = true;
        locationAPI
          .search(this.searchCityControl)
          .then((res) => {
            let dataSource = res.data;
            if (!dataSource || dataSource.length < 1) {
              dataSource = [{ _id: "0", name: "موردی یافت نشد!" }];
              this.noResult = true;
            }
            resolve(dataSource);
          })
          .catch((err) => {
            reject(err);
          })
          .then(() => (this.isLoading = false));
      });
    },

    closeDialog() {
      this.$store.commit("setState", { isSearchCityOpen: false });
    },

    handleSubmit(event) {
      // if (!this.isPersianAlphabet || !this.searchCityControl) return;
      if (!this.selectedCity) return;

      this.$store.commit("setQueryParams", {
        sub: {
          ...this.$store.state.queryParams.sub,
          // xq: this.searchCityControl.trim(),
          xq:
            this.$store.state.queryParams.xb === VersionTypesEnum.PlayStore
              ? {
                  cityFaName: this.selectedCity.name,
                  cityEnName: this.selectedCity.nameEn,
                  cityCustomName: "",
                }
              : this.selectedCity.name, //////// if it's google play, city must set as object
          xk: this.selectedCity.lat,
          xl: this.selectedCity.long,
        },
      });
      this.searchCityControl = "";
      this.selectedCity = null;
      this.closeDialog();
      this.$store.dispatch("getWeather");
    },

    // setFocus() {
    //   this.$refs.searchInputRef.focus();
    // },

    handleCitySelect(val) {
      this.selectedCity = val;

      let cityTitle = "";
      if (
        !this.$store.state.queryParams.sub.xo ||
        this.$store.state.queryParams.sub.xo == LanguagesEnum.fa
      )
        cityTitle = val.name ? val.name : val.nameEn;
      else cityTitle = val.nameEn ? val.nameEn : val.name;

      setTimeout(() => {
        this.$refs.searchInputRef.setText(cityTitle);
      });
    },
  },
};
</script>
